import React, { CSSProperties } from 'react'
import * as styles from './RankRow.module.scss'
import ArrowUp from './assets/arrow_up.svg'

export interface RankProps {
  rank: number
  name: string
  points: string
  highlighted?: boolean
  showCounter?: boolean
  style?: CSSProperties
}

const RankRow: React.FC<RankProps> = ({ rank, name, points, highlighted = false, style = {}, showCounter = false }) => {
  return (
    <div
      style={style}
      className={highlighted ? styles.highlightedRow : styles.row}
    >
      {highlighted && (<ArrowUp className={styles.arrowLeft} />)}
      <div className={styles.rank}>
        {rank}
        {highlighted && (
          <div
            className={styles.counter}
            style={{
              opacity: showCounter ? 1 : 0,
              transition: showCounter ? 'opacity 0.5s linear' : 'opacity 0.1s linear'
            }}
          >+1
          </div>
        )}
      </div>
      <div className={styles.name}>
        {name}
      </div>
      <div className={styles.points}>
        {points} CodinPoints
      </div>
      {highlighted && (<ArrowUp className={styles.arrowRight} />)}
    </div>
  )
}

export default RankRow
